export default "__VITE_ASSET__BaPxNccM__"